<script setup>
import Flycard from "../components/Flycard.vue";

import { ref, reactive, inject, computed, onMounted } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/swiper.scss";

const { categoryList, curCategory, curCategoryIndex, changeCurCategory } = inject(
  "useDataHook"
);

let swiperInstance = reactive({});
let thumbsSwiperInstance = reactive({});

const onSlideInit = (swiper) => {
  swiperInstance = swiper;
};
const onthumbsSlideInit = (swiper) => {
  thumbsSwiperInstance = swiper;
};

const onSlideChange = (swiper) => {
  let direction = swiper.swipeDirection;

  if (direction === "next") {
    thumbsSwiperInstance.slideNext();
    changeCurCategory(1);
  } else if (direction === "prev") {
    thumbsSwiperInstance.slidePrev();
    changeCurCategory(0);
  }
};

const setThumbsSwiperPos = (swiper) => {
  if (categoryList.length === 1) return false;
  if (swiper.realIndex < categoryList.length && swiper.realIndex != curCategoryIndex) {
    
    thumbsSwiperInstance.slideToLoop(swiper.realIndex, 0);
  }
};

let t = null;
const onTransitionEnd = (swiper) => {

  if (!t) {
    t = setTimeout(async () => {
      setThumbsSwiperPos(swiper);
      t = null;
    }, 300);
  }
};
</script>

<template>
  <div class="swiper" v-if="categoryList.length">
    <div class="thumbs-swiper-container" v-if="categoryList.length > 1">
      <swiper
        class="thumbs-swiper"
        :centered-slides="true"
        :slidesPerView="5"
        :loop="true"
        :long-swipes-ratio="0.4"
        @init="onthumbsSlideInit"
      >
        <swiper-slide v-for="(item, index) in categoryList" :key="index">
          <div :class="['thumb', curCategoryIndex == index ? 'thumb-active' : '']">
            <!-- <img :src="item.logo" alt="" /> -->
            <p>
              {{ item.name }}
            </p>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="cards-swiper-container">
      <swiper
        class="cards-swiper"
        bgvtr
        :loop="categoryList.length > 1"
        @init="onSlideInit"
        @slideChange="onSlideChange"
        @transition-end="onTransitionEnd"
      >
        <swiper-slide v-for="(item, index) in categoryList" :key="index">
          
          <Flycard :categoryIndex="index" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.logo {
  height: 70px;
}
.swiper {
  height: 100%;
  top: 0;

  .thumbs-swiper-container {
    width: $--thumbsSwiper-width;
    height: $--thumbsSwiper-height;
    line-height: $--thumbsSwiper-height;
    margin: 0 auto;
    position: absolute;
    top: 120px;
    left: calc((100% - $--thumbsSwiper-width) / 2);
    font-size: 26px;
    color: #fff;

    .thumb {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 80px;
        height: 80px;
        border-radius: 8px;
      }
    }
  }

  .cards-swiper-container {
    z-index: 66;
    height: 100%;
    .cards-swiper {
      height: 100%;
    }
  }
}
</style>
